import React from 'react';
import classNames from 'classnames';

export const UspGridColorOptions = [
  'blue',
  'blue02',
  'green',
  'green-02',
  'magenta',
  'magenta-02',
  'purple',
  'purple-02',
  'mint',
  'mint-02',
  'pink',
  'orange',
  'kn-lightblue',
  'kn-lightgray',
  'c4s-orange',
  'c4s-blue',
  'zfz-red',
  'zfz-beige',
  'kh-iceblue',
  'innuce-yellow',
  'hsba-blue',
  'imc-black',
  'ahab-blue',
  'tafel-orange',
];
type UspGridColorType = (typeof UspGridColorOptions)[number];

interface UspGridProps {
  /** 3 Unique selling points (Usp components). */
  children: React.ReactElement[];
  /** CSS class name. */
  className?: string;
  /** Background color of the elements. */
  color?: UspGridColorType;
  /** Headline for the selling points. */
  header?: React.ReactElement;
}

/** Displays 3 unique selling points with different shade of background color. */
const UspGrid = ({ children, className, color, header }: UspGridProps) => {
  const colorClasses = [color, `${color}-light`, `${color}-dark`]; // TODO: make this less constraint?
  const processedChildren = children.map((child, index) =>
    React.cloneElement(child, {
      className: colorClasses[index],
      // eslint-disable-next-line react/no-array-index-key
      key: `index_${index}`,
    }),
  );

  return (
    <div className={classNames(className, 'ce ce-usp-grid')}>
      {header}
      <div className="ce-usp-grid-wrapper">{processedChildren}</div>
    </div>
  );
};

UspGrid.defaultProps = {
  className: null,
  color: 'blue',
  header: null,
};

export default UspGrid;
